import { render, staticRenderFns } from "./RankingDetailsModal.vue?vue&type=template&id=57a65915&scoped=true"
import script from "./RankingDetailsModal.vue?vue&type=script&lang=js"
export * from "./RankingDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RankingDetailsModal.vue?vue&type=style&index=0&id=57a65915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a65915",
  null
  
)

export default component.exports